export const Titles = {
    unsubscribe: 'Unsubscribe',
    leadManagement: 'Lead Management'
};
